import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/create-duck";

const { Types, Creators } = createActions(
  {
    request: ["postData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "CREATE_PICKING_FILE_" }
);

export interface CreatePickingFileState extends IState {}

const INITIAL_STATE: CreatePickingFileState = {
  loading: false,
  error: null,
};

const request = (state: CreatePickingFileState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: CreatePickingFileState,
  action: ISuccessAction
) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (
  state: CreatePickingFileState,
  action: IFailureAction
) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const createPickingFile = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const CreatePickingFileTypes = Types;
export const CreatePickingFileActions = Creators;